import List from 'list.js'

const elements = {}
const filter = {}
const sorting = {
	key: 'date',
	order: 'desc',
}

elements.container = document.querySelector('#filter')

if (elements.container) {
	elements.form = elements.container.querySelector('.filter-form')
	elements.list = elements.container.querySelector('.filter-list')
	elements.filter = elements.container.querySelectorAll('input[data-filter]')

	// populate filter values
	elements.filter.forEach(filterElement => {
		const key = filterElement.dataset.filter
		if (!filter.hasOwnProperty(key)) {
			filter[key] = []
		}
		if (filterElement.checked && filterElement.value) {
			filter[key].push(filterElement.value)
		}
	})

	// initialize list.js
	const filterList = new List(elements.container.id, {
		listClass: elements.list.className,
		valueNames: [
			'title',
			{ data: ['date', 'genre', 'type', 'medium', 'age', 'language'] },
		],
	})

	const defaultSorting = elements.container.querySelector(`[data-order][data-default-order]`)
	if (defaultSorting) {
		sorting.key = defaultSorting.dataset.sort
		sorting.order = defaultSorting.dataset.order
	}

	const url = new URL(window.location.href)

	// get applied filters from url
	Object.keys(filter).forEach(key => {
		const value = url.searchParams.get(key)?.split(',')

		if (value && value.length) {
			filter[key] = value
			const elements = elements.container.querySelectorAll(`[data-filter="${key}"]`)

			elements.forEach(element => {
				if (value.includes(element.value)) {
					if (element.matches(':not(:checked)')) {
						element.click()
					}
				} else {
					if (element.matches(':checked')) {
						element.click()
					}
				}
			})
		}
	})

	// get sorting from url
	if (url.searchParams.has('sortKey')) {
		sorting.key = url.searchParams.get('sortKey')
	}
	if (url.searchParams.has('sortOrder')) {
		sorting.order = url.searchParams.get('sortOrder')
	}

	filterList.filter(filterFunction)
	filterList.sort(sorting.key, { order: sorting.order })
	handleResults(filterList)

	// update sorting in url
	filterList.on('sortComplete', ({ listContainer, sortClass }) => {
		const currentSorting = listContainer.querySelector(`.${sortClass}.asc, .${sortClass}.desc`)
		if (currentSorting) {
			sorting.key = currentSorting.dataset.sort
			sorting.order = currentSorting.dataset.order
		}

		filterToUrl()
	})

	elements.form.addEventListener('change', event => {
		const filterKey = event.target.dataset.filter

		// get all values that match the current filter
		const filterValues = Array.from(elements.filter)
			.filter(filterElement => filterElement.matches(`[data-filter="${filterKey}"]:checked`))
			.map(filterElement => filterElement.value)

		filter[filterKey] = filterValues

		filterList.filter(filterFunction)
		filterList.sort(sorting.key, { order: sorting.order })
		handleResults(filterList)
		filterToUrl()
	})
}

function filterFunction(item) {
	const itemValues = item.values()

	return Object.keys(filter).every(key => {
		const values = filter[key]

		if (!values.length) {
			return true
		}

		// compare dates
		if (key === 'date') {
			const filterDates = values.map(value => new Date(value).getFullYear())
			const targetDate = new Date(itemValues[key]).getFullYear()

			return filterDates.includes(targetDate)
		}

		return values.includes(itemValues[key])
	})
}

function filterToUrl() {
	const url = new URL(window.location.href)

	Object.keys(filter).forEach(key => {
		const value = filter[key]
		if (value.length) {
			url.searchParams.set(key, value)
		} else {
			if (url.searchParams.has(key)) {
				url.searchParams.delete(key)
			}
		}
	})

	url.searchParams.set('sortKey', sorting.key)
	url.searchParams.set('sortOrder', sorting.order)

	window.history.replaceState(null, null, url.href)
}

/**
 * Handles UI updates after a filter has been applied
 * @param {List} List List.js instance
 */
function handleResults(List) {
	const { list, listContainer, matchingItems } = List

	const dropdowns = listContainer.querySelectorAll('.dropdown[data-filter]')
	dropdowns.forEach(dropdown => {
		const dropdownToggle = dropdown.querySelector('[data-bs-toggle="dropdown"]')
		dropdownToggle.classList.toggle('active', dropdown.querySelector(`:checked`))
	})

	const noResults = listContainer.querySelector('.filter-no-results')
	if (noResults) {
		const hasResults = matchingItems.length
		noResults.hidden = hasResults
		list.hidden = !hasResults
	}
}
